// extracted by mini-css-extract-plugin
export default {"buttonPanel":"styles_buttonPanel__CGLXg","coinsRef":"styles_coinsRef__4wgR6"};